import { useEffect, useContext } from "react";
import { GlobalContext } from "../component/GlobalContext";
import { Outlet } from "react-router-dom";
import BottomBar from "../component/ps/bottom/BottomBar";

import "../sass/styles.scss";
import MyModal from "../component/ps/modals/Modal";
import { ChakraProvider } from "@chakra-ui/react";
import DefaultLayout from "../layouts/default";
import theme from "../theme";

const PresentationServer = () => {
  const { userInfo, settings, runCode, forms, setLoading } =
    useContext(GlobalContext);

  useEffect(() => {
    setLoading(true);
    if (userInfo && userInfo.token) {
      runCode({
        code: "show forms",
        token: userInfo.token,
      })
        .then((data) => {
          if (data.output) {
            forms.current = data.output.sort((a, b) =>
              a["FORMS"].localeCompare(b["FORMS"])
            );
          }
          setTimeout(() => {
            setLoading(false);
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <DefaultLayout
        navbarVariant="presentation-server"
        baseStyleWorkaround={true}
        withFooter={false}
      >
        <article className="content">
          <div className="background"></div>
          <Outlet />
          {settings.modals.show && <MyModal />}
        </article>
        <BottomBar />
      </DefaultLayout>
    </ChakraProvider>
  );
};

export default PresentationServer;
